import { render, staticRenderFns } from "./Chip.vue?vue&type=template&id=38b75185&"
var script = {}
import style0 from "./Chip.vue?vue&type=style&index=0&id=38b75185&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports